export default "__VITE_ASSET__DPu2ZL0___"